import React from "react";

import { MetaTagsBlock as Value } from "@reactivated";

import { notEmpty } from "../../utils/functional";
import { assertNever } from "../../utils/never";
import { DomainVerificationBlock } from "./DomainVerificationBlock";
import { GoogleTagManagerBlock } from "./GoogleTagManagerBlock";
import { OneTrustCookieSettingsBlock } from "./OneTrustCookieSettingsBlock";

/**
 * MetaTagsBlock
 *
 * Due to how react-helmet-aync works, this can't be written as a normal React
 * component. Rather, it has to be a plain function which returns a flat list of
 * <meta/> tags.
 */
export const MetaTagsBlock = (props: {
    tags: Value;
    cspNonce?: string | null;
}): React.JSX.Element[] => {
    return props.tags
        .flatMap((block) => {
            try {
                switch (block.type) {
                    case "domain_verification": {
                        return DomainVerificationBlock(block);
                    }
                    case "gtm": {
                        return GoogleTagManagerBlock({
                            ...block,
                            cspNonce: props.cspNonce,
                        });
                    }
                    case "onetrust_cookie_settings": {
                        return OneTrustCookieSettingsBlock(block);
                    }
                }
                assertNever(block);
            } catch (e) {
                console.error(e);
            }
            return null;
        })
        .filter(notEmpty);
};
